import { defineStore } from 'pinia';
import {
  ref,
  type Ref,
  type Component,
  type ComputedRef
} from 'vue';
import { STEPS } from '@/services/const.enum';


export const useOrderViewStore = defineStore('OrderViewStore', () => {

  const cards: Ref<Card[]> = ref([]);
  const recapitulationDetails: Ref<RecapitulationDetail[]> = ref([]);


  function addRecapitulationDetail(detail: RecapitulationDetail) {
    recapitulationDetails.value.push(detail);
  }

  function addCard(card: Card) {
    cards.value.push(card);
  }

  function removeCards() {
    cards.value = [];
  }

  function removeRecapitulationDetails() {
    recapitulationDetails.value = [];
  }

  return { addCard, addRecapitulationDetail, removeCards, removeRecapitulationDetails, cards, recapitulationDetails };
});

interface Card {
  name: string,
  step: () => STEPS,
  isShown: ComputedRef<boolean>,
  isReadOnly: ComputedRef<boolean>,
}

interface RecapitulationDetail {
  component: () => Component,
  props: {
    [key: string]: Object
  }
}
